import React, { useContext, useState, useEffect } from 'react';
import { InputContext } from '../contexts/InputContext';
import authServices from '../services/authServices';
import MessageModal from '../container/MessageModal';
import { errorClassification } from '../errorHandler';
import { useNavigate, useParams } from "react-router-dom";
import usuariosServices from '../services/usuariosServices';

const ActivarUsuario = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false);
  const [tieneToken, setTieneToken] = useState(false);

  let { token } = useParams();

  useEffect(() => {
    if(authInformation.autenticado === true){
      navigate(`/`);
    } else {
      setRenderHTML(true)

      if(token){
        setTieneToken(true)
        activarUsuario(token)
      } else {
        setTieneToken(false)
      }
    }

  }, [authInformation, token]);


  const activarUsuario = async (token) => {
    try {
      const data = await usuariosServices.activarUsuario({token: token});

      alert(data.message)
      navigate(`/ingreso`);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  return (
    <>
      {
        renderHTML && (
          <main className="w-100 m-auto" style={{maxWidth: '660px'}}>
            <form>
              <div className="card mb-3">
                <div className="card-body">
                  {
                    tieneToken ? (
                      <>
                        <h5 className="card-title">Activando ...</h5>
                      </>
                    ) : (
                      <>
                        <h5 className="card-title">Error en la activación</h5>
                      </>
                    )
                  }

                </div>
              </div>
            </form>
          </main>
        )
      }

    </>
  );
};

export default ActivarUsuario;